import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasListItem = ({ children, className, button, onClick, selected, disablePadding, sx, ...props }) => (
  <li
    onClick={onClick}
    className={cn(
      'flex items-center px-4 py-2',
      !disablePadding && 'px-4',
      button && 'cursor-pointer hover:bg-gray-100 transition-colors',
      selected && 'bg-primary/10 text-primary',
      className
    )}
    {...props}
  >
    {children}
  </li>
)

AdasListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  button: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  disablePadding: PropTypes.bool
}
